<template>
  <div>
    <!-- 当前任务 -->
    <template v-if="colType == 'taskName'">
      <div v-for="(tasks, key) in taskGroups" :key="key" style="white-space: nowrap">
        <div>{{ tasks[0].name.replaceAll(' ', '') }}</div>
      </div>
    </template>

    <!-- 审批人 -->
    <template v-else>
      <div
        v-for="(tasks, key) in taskGroups"
        :key="key"
        class="div-task-group"
        :class="Object.keys(taskGroups).length > 1 ? 'div-task-group-border' : ''"
      >
        <p>{{ tasks[0].name.replaceAll(' ', '') }}</p>
        <p v-if="!tasks[0].candidateUsers" style="color: var(--color-grey); margin-top: 0; margin-bottom: 0">
          无审批人
        </p>

        <div
          v-for="(task, taskIndex) in tasks"
          :key="task.id"
          class="div-task"
          :class="(task.parallelFlag || task.paralleltask) ? 'div-task-parallel' : ''"
        >
          <a-popover
            placement="topRight"
            :title="user.realname"
            trigger="hover"
            v-for="(user, userIndex) in task.candidateUsers"
            :key="user.id"
          >
            <template slot="content">
              <div class="a-popover-user-info" style="margin-top: -5px; margin-bottom: -5px">
                <p>
                  <a-icon type="idcard" theme="twoTone" />
                  <span>{{ user.username }}</span>
                </p>
                <p>
                  <a-icon type="phone" theme="twoTone" />
                  <span>{{ user.phone }}</span>
                </p>
                <p>
                  <a-icon type="mail" theme="twoTone" />
                  <span>{{ user.email }}</span>
                </p>
              </div>
            </template>

            <div class="div-candidate">
              <span>{{ user.realname }}</span>
              <span class="agent-meta-arrow" v-if="!!user.agentMetaRealName"><a-icon type="arrow-down" /></span>
              <span class="agent-meta-span" v-if="!!user.agentMetaRealName">{{ user.agentMetaRealName }}</span>

              <template v-if="forProcess && !task.paralleltask">
                <a-icon v-if="task.taskActive == false" type="check-circle" theme="twoTone" two-tone-color="#52c41a" />
              </template>

              <template v-else>
                <a-icon v-if="user.taskActive == false" type="check-circle" theme="twoTone" two-tone-color="#52c41a" />
              </template>
            </div>

            <template v-if="forProcess">
              <a-divider v-if="tasks.length != taskIndex + 1"></a-divider>
              <a-divider v-if="task.candidateUsers.length != userIndex + 1"></a-divider>
            </template>

            <template v-else>
              <a-divider v-if="task.candidateUsers.length != userIndex + 1"></a-divider>
            </template>
          </a-popover>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'TaskColumn',
  mixins: [],
  components: {},
  props: {
    // 列类型
    colType: {
      type: String,
      default: 'taskName',
    },
    // 行数据
    record: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      taskGroups: {},
      forProcess: true,
    }
  },
  computed: {},
  watch: {},
  created() {
    // 流程单位
    if (this.record.lstTask && this.record.lstTask.length > 0) {
      this.forProcess = true
      this.taskGroups = XEUtils.groupBy(this.record.lstTask, 'taskDefinitionKey')
    }
    // 任务单位
    else if (this.record.candidateUsers && this.record.candidateUsers.length > 0) {
      this.forProcess = false
      this.taskGroups[this.record.taskDefinitionKey] = [this.record]
    }
  },
  methods: {},
}
</script>
<style lang="less" scoped>
.div-task-group {
  margin-top: 2px;
  margin-bottom: 2px;

  p {
    display: none;
  }

  .div-task {
    display: flex;
    flex-direction: column;
  }

  .div-candidate {
    color: var(--color-primary);
    background: var(--color-primary-1);
    min-height: 26px;
    line-height: 26px;
    text-align: center;
    position: relative;
  }

  .ant-divider-horizontal {
    margin: 2px 0px 1px !important;
    border-bottom: none !important;
    background: transparent;
  }

  .div-task-parallel .ant-divider-horizontal {
    margin: 5px 0px 5px !important;
    border-bottom: 1px dashed #dfdfdf !important;
  }

  &.div-task-group-border {
    //padding: 4px;
    //border: 1px dashed var(--color-tb-border);

    p {
      display: block;
      margin-top: 12px;
      margin-bottom: 2px;
      text-align: center;
      font-size: 12px;
      white-space: nowrap;
    }

    &:first-child p {
      margin-top: 0;
    }
  }

  .anticon-check-circle {
    position: absolute;
    top: -3px;
    right: -4px;
    font-size: 13px;
  }

  .agent-meta-arrow {
    margin: -1px 0px 0px;
    color: var(--color-grey);
    display: block;
    line-height: 10px;
    font-size: 15px;
  }

  .agent-meta-span {
    color: var(--color-grey);
  }
}
</style>
